<div class="contact">
  <app-page-header
    breadcrumb="Uncomplicate Your World."
    [doubleArrows]="true"
    title="Contacts"
    [keepIconOnMobile]="true"></app-page-header>
  <div class="contact__body">
    <div class="contact__intro">
      <span class="contact__intro--eyebrow"
        >We&rsquo;ve got your back<span class="sgl-arrows" aria-hidden="true"></span
      ></span>
      <h1 class="contact__intro--heading">Reach the right team in one step.</h1>
      <p class="contact__intro--description">
        Your dedicated support contacts are below — or find your nearest of 200+ offices on our global site.
      </p>
    </div>
    <div class="contact__layout">
      <div class="contact__main">
        @if (contactSections$ | async; as sections) {
          @if (sections.people.length || sections.departments.length) {
            @if (sections.people.length) {
              <div class="contact__section-label">
                Your People<span class="sgl-arrows" aria-hidden="true"></span>
                <span class="contact__section-label--count"
                  >{{ sections.people.length }} {{ sections.people.length === 1 ? 'person' : 'people' }}</span
                >
              </div>
              <div class="contact__persons">
                @for (person of sections.people; track person.id) {
                  <app-contact-item [contact]="person"></app-contact-item>
                }
              </div>
            }
            @if (sections.departments.length) {
              <div class="contact__section-label">Departments<span class="sgl-arrows" aria-hidden="true"></span></div>
              <div class="contact__departments">
                @for (department of sections.departments; track department.id) {
                  <app-department-item [department]="department"></app-department-item>
                }
              </div>
            }
          } @else {
            <app-contact-item [contact]="defaultContactInfo"></app-contact-item>
          }
        } @else {
          <div class="contact__skeleton">
            <div class="contact__skeleton--header"></div>
            <div class="contact__skeleton--items">
              @for (skeleton of numberOfSkeletons; track index; let index = $index) {
                <app-contact-item-skeleton></app-contact-item-skeleton>
              }
            </div>
          </div>
        }
      </div>
      <div class="contact__sidebar">
        <app-general-info></app-general-info>
      </div>
    </div>
  </div>
</div>
